import React from 'react';
import { Link } from 'react-router-dom';
import './css/Hero.css';

const Hero: React.FC = () => {
  return (
    <div className="container">
      <section className="hero">
        <div className="hero-content">
          <div className="hero-tag">// Cloud Architecture & Development : </div>
          <h1>Transform Your Business with AI and Azure</h1>
          <p>
            Expert Azure migration, architecture, and custom application development. 
            We build scalable, secure cloud solutions tailored to your needs.
          </p>
          <div className="hero-assessment-callout">
            <span>✦ New:</span>
            <Link to="/assessment">AI Business Assessment — find out where your business is losing time →</Link>
          </div>
          <div className="cta-group">
            <a href="#contact" className="btn btn-primary">Start Your Project</a>
            <a href="#services-grid" className="btn btn-secondary">Our Services</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Hero;
